import { Pagination, type PaginationProps } from "components/Pagination";

export type TableLayoutFooterProps = PaginationProps & {
  showingFrom: number;
  showingTo: number;
  totalLabel?: string;
};

export const getTableShowingRange = (
  page: number,
  limit: number,
  total: number,
) => ({
  showingFrom: total === 0 ? 0 : (page - 1) * limit + 1,
  showingTo: Math.min(page * limit, total),
});

export const TableLayoutFooter = ({
  showingFrom,
  showingTo,
  total,
  totalLabel = "dòng",
  ...paginationProps
}: TableLayoutFooterProps) => (
  <>
    <span className="tableLayoutFooterSummary">
      Hiển thị {showingFrom} đến {showingTo} trong tổng {total} {totalLabel}
    </span>
    <Pagination
      embedded
      showSizeChanger
      showQuickJumper={false}
      total={total}
      {...paginationProps}
    />
  </>
);
